var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.hasChannelAccess)?_c('div',{staticClass:"header-promotion",class:{ 'header-promotion--sticky': _vm.isSticky },attrs:{"id":"header-promotion"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }